/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{direction:rtl}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
